import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";

const floatingItems = [
  {
    href: "tel:+966556641963",
    label: "اتصل 0556641963",
    icon: Phone,
    bg: "#D4AF37",
  },
  {
    href: "tel:+966534859731",
    label: "اتصل 0534859731",
    icon: Phone,
    bg: "#B8960C",
  },
  {
    href: "https://wa.me/966556641963",
    label: "واتساب 0556641963",
    icon: MessageCircle,
    bg: "#25D366",
  },
  {
    href: "https://wa.me/966534859731",
    label: "واتساب 0534859731",
    icon: MessageCircle,
    bg: "#25D366",
  },
];

const FloatingActionMenu = () => {
  return (
    <div className="fixed bottom-20 lg:bottom-6 left-4 z-40 flex flex-col gap-2">
      {floatingItems.map((item, i) => (
        <motion.a
          key={item.label}
          href={item.href}
          target={item.href.startsWith("http") ? "_blank" : undefined}
          rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
          aria-label={item.label}
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 1 + i * 0.15, type: "spring", stiffness: 200, damping: 18 }}
          whileHover={{ scale: 1.12 }}
          whileTap={{ scale: 0.93 }}
          className="w-14 h-14 min-w-[48px] min-h-[48px] rounded-full flex items-center justify-center shadow-lg relative"
          style={{ backgroundColor: item.bg }}
        >
          <motion.span
            className="absolute inset-0 rounded-full"
            style={{ backgroundColor: item.bg }}
            animate={{ scale: [1, 1.35], opacity: [0.4, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut", delay: i * 0.3 }}
          />
          <item.icon className="w-7 h-7 relative z-10" style={{ color: "white" }} />
        </motion.a>
      ))}
    </div>
  );
};

export default FloatingActionMenu;
